import { jsx } from 'react/jsx-runtime';
import '../IndexLayoutOld/index.js';
import { IndexLayoutLoading } from '../IndexLayoutOld/IndexLayoutLoading.js';

const WorkspaceSubscribeLoadingPage = () => (jsx(IndexLayoutLoading, { variant: "orange" }));

export { WorkspaceSubscribeLoadingPage };
